import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Layout from '../components/Layout';
import { claimsAPI } from '../services/api';
import { useAuth } from '../contexts/AuthContext';

const Dashboard = () => {
  const { user } = useAuth();
  const [claims, setClaims] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    loadDashboard();
  }, []);

  const loadDashboard = async () => {
    try {
      const claimsRes = await claimsAPI.getAll();
      setClaims(claimsRes.data);
      setError('');
    } catch (error) {
      console.error('Error loading dashboard:', error);
      setError('Error loading dashboard data');
    } finally {
      setLoading(false);
    }
  };

  if (loading) return <Layout><div>Loading...</div></Layout>;

  return (
    <Layout>
      <h2 style={{ marginBottom: '2rem' }}>Welcome, {user.first_name} {user.last_name}!</h2>

      {error && (
        <div style={{ padding: '1rem', marginBottom: '1rem', background: '#f8d7da', borderRadius: '4px', color: '#721c24' }}>
          {error}
        </div>
      )}

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '1rem', marginBottom: '2rem' }}>
        <div style={{ padding: '1.5rem', background: '#3498db', color: 'white', borderRadius: '8px' }}>
          <h3 style={{ margin: '0 0 0.5rem 0', fontSize: 'clamp(1rem, 3vw, 1.2rem)' }}>Active Claims</h3>
          <p style={{ fontSize: 'clamp(1.5rem, 5vw, 2rem)', margin: 0 }}>{claims.length}</p>
        </div>
      </div>

      <h3 style={{ marginBottom: '1.5rem' }}>Your Claims</h3>
      {claims.length === 0 ? (
        <div style={{ background: 'white', padding: '2rem', borderRadius: '8px', border: '1px solid #ddd', textAlign: 'center' }}>
          <p style={{ marginBottom: '1rem', color: '#666' }}>No active claims found.</p>
          <p style={{ fontSize: '0.9rem', color: '#888' }}>If you believe this is an error, please contact us.</p>
        </div>
      ) : (
        <div style={{ background: 'white', borderRadius: '8px', overflow: 'hidden', border: '1px solid #ddd' }}>
          {claims.map((claim) => (
            <div key={claim.id} style={{ padding: '1rem', borderBottom: '1px solid #ddd', display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '1rem' }}>
              <div style={{ flex: '1 1 auto', minWidth: '200px' }}>
                <h4 style={{ margin: '0 0 0.5rem 0', fontSize: 'clamp(1rem, 3vw, 1.1rem)' }}>{claim.claim_reference}</h4>
                <p style={{ margin: 0, color: '#666', fontSize: 'clamp(0.85rem, 2vw, 1rem)' }}>Status: <strong>{claim.client_status || claim.status}</strong></p>
                <p style={{ margin: '0.25rem 0 0 0', fontSize: 'clamp(0.8rem, 2vw, 0.9rem)', color: '#888' }}>
                  Last updated: {new Date(claim.last_updated).toLocaleDateString()}
                </p>
              </div>
              <div style={{ display: 'flex', gap: '0.5rem', flexWrap: 'wrap', flex: '0 1 auto', minWidth: '200px' }}>
                <Link to={`/claims/${claim.claim_reference}/additional-info`} style={{ flex: '1 1 auto', display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '0.5rem 1rem', background: '#27ae60', color: 'white', textDecoration: 'none', borderRadius: '4px', whiteSpace: 'nowrap', fontSize: 'clamp(0.85rem, 2vw, 1rem)' }}>
                  Update Info
                </Link>
                <Link to={`/claims/${claim.claim_reference}`} style={{ flex: '1 1 auto', display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '0.5rem 1rem', background: '#2c3e50', color: 'white', textDecoration: 'none', borderRadius: '4px', whiteSpace: 'nowrap', fontSize: 'clamp(0.85rem, 2vw, 1rem)' }}>
                  View Details
                </Link>
              </div>
            </div>
          ))}
        </div>
      )}

      <div style={{ marginTop: '2rem', display: 'flex', gap: '1rem', flexWrap: 'wrap' }}>
        <Link to="/communications" style={{ padding: '1rem 2rem', background: '#27ae60', color: 'white', textDecoration: 'none', borderRadius: '4px', fontSize: 'clamp(0.9rem, 2vw, 1rem)' }}>
          View Communications
        </Link>
        <Link to="/uploads" style={{ padding: '1rem 2rem', background: '#2980b9', color: 'white', textDecoration: 'none', borderRadius: '4px', fontSize: 'clamp(0.9rem, 2vw, 1rem)' }}>
          Upload Documents
        </Link>
        <Link to="/faqs" style={{ padding: '1rem 2rem', background: '#8e44ad', color: 'white', textDecoration: 'none', borderRadius: '4px', fontSize: 'clamp(0.9rem, 2vw, 1rem)' }}>
          View FAQs
        </Link>
      </div>
    </Layout>
  );
};

export default Dashboard;
